import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "separator", "currentPage", "children", "prefixCls"];
import React from 'react';
import ClassNames from 'classnames';
import BreadcrumbSeparator from './BreadcrumbSeparator';
var BreadcrumbItem = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
    separator = props.separator,
    currentPage = props.currentPage,
    children = props.children,
    _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'ap-breadcrumb' : _props$prefixCls,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var renderSeparator = function renderSeparator() {
    if (!currentPage) {
      return /*#__PURE__*/React.createElement(BreadcrumbSeparator, {
        className: prefixCls + "-separator"
      }, separator || /*#__PURE__*/React.createElement("span", {
        className: "Appkit4-icon icon-right-chevron-outline"
      }));
    }
    return null;
  };

  // const Comp = currentPage ? "span" : "a";

  return /*#__PURE__*/React.createElement("li", _extends({
    className: ClassNames(prefixCls + "-item", className, {
      'last': currentPage
    })
  }, rest), children, renderSeparator());
});
export default BreadcrumbItem;